import { createFileRoute, Navigate } from '@tanstack/react-router';

import { TestModeCard } from '@apps/web/components/settings/test_mode_card';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/test-mode')({
    component: TestModePage,
});

function TestModePage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Test Mode"
            description="Control what runs in sandbox and test workflows."
        >
            <TestModeCard organizationId={organizationId} />
        </SettingsPageShell>
    );
}
